module.exports = "./img/9f04ec4e185c0cb8c9f638368983e038.jpg";